import React from 'react';
import { Card, Button } from 'semantic-ui-react';

const defaultStyles = {
  fontSize: '11px',
};

function NoResultsFound(props) {
  const { botSteps, nextSteps } = props;
  const { newSearch, mainMenu, rateService } = nextSteps;
  const { previousStep, triggerNextStep } = botSteps;

  const nextState = (value) => {
    triggerNextStep({ value: ['TEST1', 'TEST2'], trigger: value });
  };

  return (
    <>
      <Card fluid>
        <Card.Content>
          <Card.Description>
            No se encontraron resultados con la referencia:{' '}
            <strong>{previousStep.message}</strong>
          </Card.Description>
        </Card.Content>
        <Card.Content extra>
          <div className="row" style={{ width: '100%' }}>
            <div className="col-md-6">
              <Button
                fluid
                compact
                style={defaultStyles}
                onClick={() => nextState(newSearch)}
              >
                Nueva busqueda
              </Button>
            </div>
            <div className="col-md-6">
              <Button
                fluid
                compact
                style={defaultStyles}
                onClick={() => nextState(mainMenu)}
              >
                Menu
              </Button>
            </div>
          </div>

          <div className="row" style={{ height: '10px' }} />

          <div className="row" style={{ width: '100%' }}>
            <div className="col-md-3" />
            <div className="col-md-6">
              <Button
                fluid
                compact
                style={defaultStyles}
                onClick={() => nextState(rateService)}
              >
                Salir
              </Button>
            </div>
            <div className="col-md-3" />
          </div>
        </Card.Content>
      </Card>
    </>
  );
}

export default NoResultsFound;
